export default "__VITE_ASSET__BxK5g9pm__"